/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Estonian
export default {
	'project-pages.connect-space-dialog.connection-error': 'Ühenduse loomine ebaõnnestus.',
	'project-pages.connect-space-dialog.connection-retry': 'Proovi uuesti',
	'project-pages.connect-space-dialog.content.space-selector.disconnected-templates-description':
		'Enne lehe loomist peab projekt olema ühendatud ruumiga. Projektiga ühenduse loomiseks valige ruum.',
	'project-pages.connect-space-dialog.error-icon': 'Viga:',
	'project-pages.connect-space-dialog.footer.cancel': 'Tühista',
	'project-pages.connect-space-dialog.footer.connect-space': 'Ühenda',
	'project-pages.connect-space.description':
		'Ruumid on nagu kaustad – saate neid kasutada oma projektiga seotud sisu loomiseks ja sorteerimiseks ning koostöö tegemiseks.',
	'project-pages.create-space-dialog.connection-error': 'Ühenduse loomine ebaõnnestus.',
	'project-pages.create-space-dialog.connection-retry': 'Proovi uuesti',
	'project-pages.create-space-dialog.content.empty-name': 'Andke ruumile nimi.',
	'project-pages.create-space-dialog.content.invalid-name':
		'Ruumi nimes peab olema vähemalt üks täht või number.',
	'project-pages.create-space-dialog.content.placeholder': 'Sisestage ruumi nimi',
	'project-pages.create-space-dialog.creation-error': 'Ruumi loomine ebaõnnestus.',
	'project-pages.create-space-dialog.error-icon': 'Viga:',
	'project-pages.create-space-dialog.footer.cancel': 'Tühista',
	'project-pages.create-space-dialog.footer.create-space': 'Loo',
	'project-pages.create-space-dialog.header.title': 'Uue Confluence’i ruumi loomine',
	'project-pages.default-contextual-message':
		'Confluence’i lehtede abil saate ühes kohas kõiki projektidokumente koostada ja jagada ning nende kallal koostööd teha.',
	'project-pages.default-reactivate-CTA': 'Aktiveerige Confluence uuesti',
	'project-pages.default-trial-CTA': 'Proovige Confluence’i 30 päeva tasuta',
	'project-pages.generic-error.button.reload': 'Lehekülje uuesti laadimine',
	'project-pages.generic-error.description': 'Midagi läks valesti. Proovige hiljem uuesti.',
	'project-pages.generic-error.heading': 'Oih, piinlik lugu ...',
};
